module.exports = __webpack_public_path__ + "img/cattunnel.d99e94b8.png";